
import { MousePosition, createStringXY } from '../src/ts/openlayers/ol-bridge';




export var mapControl_mousePosition = new MousePosition({
    coordinateFormat: createStringXY(4),
    // comment the following two lines to have the mouse position
    // be placed within the map.
//    className: 'custom-mouse-position',
//    target: document.getElementById('mouse-position'),
    undefinedHTML: '&nbsp;'
});











// WEBPACK FOOTER //
// ./js/cms_view_mapcontrols.js